import { Component } from '@angular/core';
import { GridFilterBase } from '../grid-filter-base/grid-filter-base';

@Component({
  selector: 'spv2-grid-efile-validation-status-filter',
  templateUrl: './grid-efile-validation-status-filter.component.html',
  styleUrls: ['./grid-efile-validation-status-filter.component.scss']
})
export class GridEfileValidationStatusFilterComponent extends GridFilterBase<string[]> {

}
